import React from 'react';

const PaymentSuccessScreen = ({ onViewProfile }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '24px',
        padding: '60px 40px',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Success Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          fontSize: '40px'
        }}>
          ✨
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1a1a1a',
          marginBottom: '16px'
        }}>
          Payment Successful!
        </h1>

        {/* Message */}
        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '40px',
          lineHeight: '1.6'
        }}>
          🎉 Congratulations! Your premium features are now unlocked. 
          <br/><br/>
          You now have access to:
        </p>

        {/* Features List */}
        <div style={{
          textAlign: 'left',
          marginBottom: '40px',
          padding: '20px',
          background: '#f8f9fa',
          borderRadius: '12px'
        }}>
          <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '12px', fontSize: '20px' }}>✅</span>
            <span style={{ color: '#333' }}>All 12+ career paths for your profile</span>
          </div>
          <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '12px', fontSize: '20px' }}>✅</span>
            <span style={{ color: '#333' }}>Interactive Vision Board</span>
          </div>
          <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '12px', fontSize: '20px' }}>✅</span>
            <span style={{ color: '#333' }}>Downloadable PDF Report</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '12px', fontSize: '20px' }}>✅</span>
            <span style={{ color: '#333' }}>Email & Social Sharing</span>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={onViewProfile}
          style={{
            width: '100%',
            padding: '18px',
            fontSize: '18px',
            fontWeight: '600',
            color: 'white',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'transform 0.2s',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          View My Premium Profile →
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;